import styled from 'styled-components'

import { FullWidthHeight } from 'components/common/genericStyles'
import { Color } from 'constants/color'

export const Wrapper = styled.div`
    width: auto;
    height: 40px;
    background: ${Color.unknownColor19};
    border-radius: 44px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 0 16px;
`

export const GiphyIconContainer = styled.div`
    width: 24px;
    height: 24px;

    margin: 0 16px 0 12px;
    cursor: pointer;
`

export const GiphyImage = styled.img`
    ${FullWidthHeight};
`
